<template lang="">
    <b-row>
        <b-card class="mt-2 col-12">
            <b-row>
                <b-col md="4">
                    <b-form-group label="รหัสผู้ประกอบการ" label-for="companyID" >
                        <b-form-input id="companyID" v-model="ComplaintGroup.companyID" placeholder="รหัสผู้ประกอบการ" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <b-form-group label="ชื่อผู้ประกอบการ" label-for="companyName" >
                        <b-form-input id="companyName" v-model="ComplaintGroup.companyName" placeholder="ชื่อผู้ประกอบการ" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group
                    label="หมายเหตุ"
                    label-for="companyDetail" >
                        <b-form-input
                            id="companyDetail"
                            v-model="ComplaintGroup.companyDetail"                        
                            placeholder="หมายเหตุ"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                 <b-col cols="12" class="d-flex justify-content-between pt-2">
                    <b-button variant="secondary" @click="onCancel">ยกเลิก</b-button>
                    <b-button variant="primary mr-1" @click="onAddSubmit">บันทึก</b-button>
                </b-col>
            </b-row>
        </b-card >

    </b-row>
</template>
<script>
import {
  BRow, BCol, BTabs, BTab, BButton, BCard, BCardHeader, BCardBody,BFormGroup,BFormInput,BModal
} from 'bootstrap-vue'
import * as ComplaintGroupStore from "@/store/api/ComplaintGroup/ComplaintGroup.js";
import * as userData from "@/auth/localStorageUtils.js";
export default {
    components: {
        BRow,
        BCol,
        BButton,
        BTabs,
        BTab,
        BCard,
        BCardHeader,
        BCardBody,
        BFormGroup,
        BFormInput,
        BModal,
    },
    data() {
        return {
            ComplaintGroup:[]
        };
    },
    methods: {
        onCancel() {
            this.$emit('onCancel')
        },
        onAddSubmit() {
            const _this = this;
            this.$swal({
                title: "ยืนยันการบันทึกข้อมูล?",
                text: "",
                icon: "success",
                showCancelButton: true,
                confirmButtonText: "บันทึก",
                cancelButtonText: "ยกเลิก",
                customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-outline-primary ml-1",
                },
                buttonsStyling: false,
                }).then((result) => {
                    if(result.value){
                        const data = {
                            companyID: this.ComplaintGroup.companyID,
                            companyName: this.ComplaintGroup.companyName,
                            companyDetail: this.ComplaintGroup.companyDetail,
                            departmentId: userData.departmentId(),
                            provinceCode: userData.province(),
                        };
                        ComplaintGroupStore
                        .addComplaintGroup(data)
                        .then((response) => {
                            console.log("response", response)
                            _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                                title: `ระบบได้บันทึกข้อมูลของท่านแล้ว`,
                                variant: "success",
                                solid: false,
                            });
                        })
                        .catch((error) => { 
                            console.log("err", error)
                        })
                    }                        
                })
        }
    }
     
}
</script>
<style lang="">
    
</style>